import { AxiosResponse } from 'axios';
import {
  SET_ATTENDANCE_LOGS,
  SET_ATTENDANCE_LOG,
  SET_ERRORMSG,
  SET_USER_ATTENDANCE_LOGS,
  SET_CALENDAR_ATTENDANCE_LOGS,
  SET_ATTENDANCE_REPORT,
  SET_USER_ATTENDANCE_DAYS,
  SET_ATTENDANCE_ANALYTICS,
  SET_ATTENDANCE_DAY_RECORDS,
  SET_ATTENDANCE_EXPORT,
} from '@/store/mutation_types';
import {
  GET_ATTENDANCE_LOGS,
  CLEAR_ATTENDANCE_LOG_ISLOADING,
  GET_EMPLOYEES_ATTENDANCE_LOGS,
  GET_CALENDAR_ATTENDANCE_LOGS,
  REGISTER_ATTENDANCE_LOG,
  GET_ATTENDANCE_REPORT,
  GET_EMPLOYEES_ATTENDANCE_DAYS,
  GET_ATTENDANCE_ANALYTICS,
  GET_ATTENDANCE_DAY_RECORDS,
  EXPORT_ATTENDANCE,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import AttendanceLog from '@/services/attendance_log';
import { Module } from 'vuex';
import { AttendanceAnalyticsParams, GetAttendanceLog, RegisterAttendanceLog } from '@/dtos/attendance_log.dto';

const attendanceLog: Module<any, {}> = {
  state: {
    attendanceLog: {
      data: null,
      isLoading: false,
    },
    attendanceLogs: {
      data: null,
      metaData: null,
      isLoading: false,
    },
    calendarAttendanceLogs: {
      data: null,
      metaData: null,
      isLoading: false,
    },
    attendanceReport: {
      data: null,
      isLoading: false,
    },
    employeesAttendanceLogs: {
      data: null,
      metaData: null,
      isLoading: false,
    },
    employeesAttendanceDays: {
      data: null,
      metaData: null,
      isLoading: false,
    },
    attendanceAnalytics: {
      data: null,
      metaData: null,
      isLoading: false,
    },
    attendanceDayRecords: {
      data: null,
      metaData: null,
      isLoading: false,
    },
    attendanceExport: {
      isLoading: false,
    },
  },
  getters: {
    attendanceAnalytics: (state: { attendanceAnalytics: any }) => state.attendanceAnalytics,
    attendanceDayRecords: (state: { attendanceDayRecords: any }) => state.attendanceDayRecords,
    attendanceExport: (state: { attendanceExport: any }) => state.attendanceExport,
    attendanceLog: (state: { attendanceLog: any }) => state.attendanceLog,
    attendanceLogs: (state: { attendanceLogs: any }) => state.attendanceLogs,
    attendanceReport: (state: { attendanceReport: any }) => state.attendanceReport,
    calendarAttendanceLogs: (state: { calendarAttendanceLogs: any }) => state.calendarAttendanceLogs,
    employeesAttendanceLogs: (state: { employeesAttendanceLogs: any }) => state.employeesAttendanceLogs,
    employeesAttendanceDays: (state: { employeesAttendanceDays: any }) => state.employeesAttendanceDays,
  },
  mutations: {
    [SET_ATTENDANCE_LOG]: (
      state: { attendanceLog: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.attendanceLog.data = payload.data) : null,
        (state.attendanceLog.isLoading = payload.isLoading);
    },
    [SET_ATTENDANCE_LOGS]: (
      state: { attendanceLogs: StateObject },
      payload: { data: null; metaData: any; isLoading: any }
    ) => {
      payload.data != null ? (state.attendanceLogs.data = payload.data) : null,
        payload.metaData != null
          ? (state.attendanceLogs.metaData = payload.metaData)
          : null,
        (state.attendanceLogs.isLoading = payload.isLoading);
    },
    [SET_ATTENDANCE_REPORT]: (
      state: { attendanceReport: StateObject },
      payload: { data: null; metaData: any; isLoading: any }
    ) => {
      payload.data != null ? (state.attendanceReport.data = payload.data) : null,
        (state.attendanceReport.isLoading = payload.isLoading);
    },
    [SET_CALENDAR_ATTENDANCE_LOGS]: (
      state: { calendarAttendanceLogs: StateObject },
      payload: { data: null; metaData: any; isLoading: any }
    ) => {
      payload.data != null ? (state.calendarAttendanceLogs.data = payload.data) : null,
        payload.metaData != null
          ? (state.calendarAttendanceLogs.metaData = payload.metaData)
          : null,
        (state.calendarAttendanceLogs.isLoading = payload.isLoading);
    },
    [SET_USER_ATTENDANCE_LOGS]: (
      state: { employeesAttendanceLogs: StateObject },
      payload: { data: null; metaData: any; isLoading: any }
    ) => {
      payload.data != null ? (state.employeesAttendanceLogs.data = payload.data) : null,
        payload.metaData != null
          ? (state.employeesAttendanceLogs.metaData = payload.metaData)
          : null,
        (state.employeesAttendanceLogs.isLoading = payload.isLoading);
    },
    [SET_USER_ATTENDANCE_DAYS]: (
      state: { employeesAttendanceDays: StateObject },
      payload: { data: null; metaData: any; isLoading: any }
    ) => {
      payload.data != null ? (state.employeesAttendanceDays.data = payload.data) : null,
        payload.metaData != null
          ? (state.employeesAttendanceDays.metaData = payload.metaData)
          : null,
        (state.employeesAttendanceDays.isLoading = payload.isLoading);
    },
    [SET_ATTENDANCE_ANALYTICS]: (
      state: { attendanceAnalytics: StateObject },
      payload: { data?: any; metaData?: any; isLoading: boolean }
    ) => {
      if (payload.data !== undefined) state.attendanceAnalytics.data = payload.data;
      if (payload.metaData !== undefined) state.attendanceAnalytics.metaData = payload.metaData;
      state.attendanceAnalytics.isLoading = payload.isLoading;
    },
    [SET_ATTENDANCE_DAY_RECORDS]: (
      state: { attendanceDayRecords: StateObject },
      payload: { data?: any; metaData?: any; isLoading: boolean }
    ) => {
      if (payload.data !== undefined) state.attendanceDayRecords.data = payload.data;
      if (payload.metaData !== undefined) state.attendanceDayRecords.metaData = payload.metaData;
      state.attendanceDayRecords.isLoading = payload.isLoading;
    },
    [SET_ATTENDANCE_EXPORT]: (state: { attendanceExport: { isLoading: boolean } }, payload: { isLoading: boolean }) => {
      state.attendanceExport.isLoading = payload.isLoading;
    },
  },
  actions: {
    [GET_ATTENDANCE_ANALYTICS]: async ({ commit }: any, payload: AttendanceAnalyticsParams) => {
      commit(SET_ATTENDANCE_ANALYTICS, { isLoading: true });
      const result: AxiosResponse = await AttendanceLog.getAttendanceAnalytics(payload);
      if (result) {
        if (result.data.status) {
          commit(SET_ATTENDANCE_ANALYTICS, { data: result.data.data, metaData: result.data.metaData, isLoading: false });
          return true;
        }
        commit(SET_ATTENDANCE_ANALYTICS, { isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      }
      commit(SET_ATTENDANCE_ANALYTICS, { isLoading: false });
      return false;
    },
    [GET_ATTENDANCE_DAY_RECORDS]: async ({ commit }: any, payload: AttendanceAnalyticsParams) => {
      commit(SET_ATTENDANCE_DAY_RECORDS, { data: null, isLoading: true });
      const result: AxiosResponse = await AttendanceLog.getAttendanceDayRecords(payload);
      if (result) {
        if (result.data.status) {
          commit(SET_ATTENDANCE_DAY_RECORDS, { data: result.data.data, metaData: result.data.metaData, isLoading: false });
          return true;
        }
        commit(SET_ATTENDANCE_DAY_RECORDS, { isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      }
      commit(SET_ATTENDANCE_DAY_RECORDS, { isLoading: false });
      return false;
    },
    [EXPORT_ATTENDANCE]: async ({ commit }: any, payload: AttendanceAnalyticsParams) => {
      commit(SET_ATTENDANCE_EXPORT, { isLoading: true });
      const result: AxiosResponse = await AttendanceLog.exportAttendance(payload);
      commit(SET_ATTENDANCE_EXPORT, { isLoading: false });
      return result || false;
    },
    [REGISTER_ATTENDANCE_LOG]: async ({ commit }: any, payload: any) => {
      commit(SET_ATTENDANCE_LOG, { data: null, isLoading: true });

      const result: AxiosResponse = await AttendanceLog.registerAttendanceLog(
        payload as RegisterAttendanceLog
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_ATTENDANCE_LOG, {
            data: result.data.data,
            isLoading: false,
          });
          return true;
        }
        commit(SET_ATTENDANCE_LOG, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ATTENDANCE_LOG, { isLoading: false });
        return false;
      }
    },
    [GET_ATTENDANCE_LOGS]: async ({ commit }: any, payload: any) => {
      commit(SET_ATTENDANCE_LOGS, { data: null, isLoading: true });

      const result: AxiosResponse = await AttendanceLog.getAttendanceLogs(
        payload as GetAttendanceLog
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_ATTENDANCE_LOGS, {
            data: result.data.data,
            metaData: result.data.metaData,
            isLoading: false,
          });
          return true;
        }
        commit(SET_ATTENDANCE_LOGS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ATTENDANCE_LOGS, { isLoading: false });
        return false;
      }
    },
    [GET_ATTENDANCE_REPORT]: async ({ commit }: any, payload: any) => {
      commit(SET_ATTENDANCE_REPORT, { data: null, isLoading: true });

      const result: AxiosResponse = await AttendanceLog.getAttendanceReport(
        payload as GetAttendanceLog
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_ATTENDANCE_REPORT, {
            data: result.data.data,
            isLoading: false,
          });
          return true;
        }
        commit(SET_ATTENDANCE_REPORT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ATTENDANCE_REPORT, { isLoading: false });
        return false;
      }
    },
    [GET_EMPLOYEES_ATTENDANCE_LOGS]: async ({ commit }: any, payload: any) => {
      commit(SET_USER_ATTENDANCE_LOGS, { data: null, isLoading: true });

      const result: AxiosResponse = await AttendanceLog.getEmployeeAttendanceLogs(
        payload as GetAttendanceLog
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_USER_ATTENDANCE_LOGS, {
            data: result.data.data,
            metaData: result.data.metaData,
            isLoading: false,
          });
          return true;
        }
        commit(SET_USER_ATTENDANCE_LOGS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_USER_ATTENDANCE_LOGS, { isLoading: false });
        return false;
      }
    },
    [GET_EMPLOYEES_ATTENDANCE_DAYS]: async ({ commit }: any, payload: any) => {
      commit(SET_USER_ATTENDANCE_DAYS, { data: null, isLoading: true });

      const result: AxiosResponse = await AttendanceLog.getEmployeeAttendanceDays(
        payload as GetAttendanceLog
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_USER_ATTENDANCE_DAYS, {
            data: result.data.data,
            metaData: result.data.metaData,
            isLoading: false,
          });
          return result.data.data;
        }
        commit(SET_USER_ATTENDANCE_DAYS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_USER_ATTENDANCE_DAYS, { isLoading: false });
        return false;
      }
    },
    [GET_CALENDAR_ATTENDANCE_LOGS]: async ({ commit }: any, payload: any) => {
      commit(SET_CALENDAR_ATTENDANCE_LOGS, { data: null, isLoading: true });

      const result: AxiosResponse = await AttendanceLog.getCalendarAttendanceLogs(
        payload as GetAttendanceLog
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_CALENDAR_ATTENDANCE_LOGS, {
            data: result.data.data,
            metaData: result.data.metaData,
            isLoading: false,
          });
          return result.data.data;
        }
        commit(SET_CALENDAR_ATTENDANCE_LOGS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_CALENDAR_ATTENDANCE_LOGS, { isLoading: false });
        return false;
      }
    },
    [CLEAR_ATTENDANCE_LOG_ISLOADING]: ({ commit }) => {
      commit(SET_ATTENDANCE_LOG, { isLoading: false });
      commit(SET_ATTENDANCE_LOGS, { isLoading: false });
      commit(SET_CALENDAR_ATTENDANCE_LOGS, { isLoading: false });
      commit(SET_USER_ATTENDANCE_LOGS, { isLoading: false });
    },
  },
};

export default attendanceLog;
